import RouteConstants from '@/features/router/RouteConstants';
import { showToast } from '@/features/toasts/toastsSlice';
import { useWorkspace } from '@/features/workspaces/hooks';
import { DeleteModalWithConfirmInput } from '@/lib/Modals';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useDeleteCampaignMutation } from '@/services/endpoints/campaigns';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

type DeleteCampaignModalProps = {
  campaign?: CampaignResponse;
  closeModal: VoidFunction;
};

export const DeleteCampaignModal: FC<DeleteCampaignModalProps> = ({ campaign, closeModal }) => {
  const { t } = useTranslation('campaign');

  const workspace = useWorkspace();
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [deleteCampaign, { isLoading }] = useDeleteCampaignMutation();

  const handleDeleteCampaign = async () => {
    if (workspace.id && campaign && campaign.id)
      await deleteCampaign({
        workspaceId: workspace.id,
        campaignId: campaign.id,
      });

    closeModal();
    history.push(RouteConstants.campaigns);

    dispatch(
      showToast({
        type: ToastType.SUCCESS,
        title: t('campaignDeleted'),
        message: t('campaignRemovedSuccessfully', { campaignName: campaign?.name }),
      })
    );
  };

  return (
    <DeleteModalWithConfirmInput
      inputComparisonValue={campaign.name}
      confirmText={'campaign:deleteThisCampaign'}
      onConfirm={handleDeleteCampaign}
      onClose={closeModal}
      isLoading={isLoading}
    >
      <DeleteModalWithConfirmInput.Title>{t('deleteThisCampaign')}</DeleteModalWithConfirmInput.Title>
      <DeleteModalWithConfirmInput.Description>{t('deleteCampaignWarning')}</DeleteModalWithConfirmInput.Description>

      <DeleteModalWithConfirmInput.InputHint>
        <Trans i18nKey={'campaign:deleteCampaignConfirmation'}>
          To confirm the deletion, write here the name of the audience <strong>{{ name: campaign.name }}</strong>
        </Trans>
      </DeleteModalWithConfirmInput.InputHint>
    </DeleteModalWithConfirmInput>
  );
};
